import React, { useEffect, useRef, useState } from "react";
import {
  startOfMonth,
  endOfMonth,
  eachDayOfInterval,
  format,
  isSameDay,
  isWithinInterval,
  addMonths,
  subMonths,
} from "date-fns";
import "./CustomCalendar.css";
import moment from "moment";

const CustomCalendar = ({ onSelectDate }) => {
  const [startDate, setStartDate] = useState(
    moment(new Date()).startOf("month"),
  );
  const [endDate, setEndDate] = useState(moment(new Date()).endOf("month"));
  const [isOpen, setIsOpen] = useState(false);
  const [currentMonth, setCurrentMonth] = useState(new Date());

  const wrapperRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (startDate && endDate) {
      console.log("on Select Date", startDate, endDate);
      onSelectDate({ startDate, endDate });
    }
  }, [endDate]);

  const toggle = () => setIsOpen((prev) => !prev);

  const selectDate = (date) => {
    if (!startDate || endDate) {
      setStartDate(date);
      setEndDate(null);
    } else {
      if (date < startDate) {
        setStartDate(date);
      } else {
        setEndDate(date);
      }
    }
  };

  const days = eachDayOfInterval({
    start: startOfMonth(currentMonth),
    end: endOfMonth(currentMonth),
  });

  const isInRange = (day) => {
    if (startDate && endDate) {
      return isWithinInterval(day, { start: startDate, end: endDate });
    }
    return false;
  };

  return (
    <div className="drp-wrapper" ref={wrapperRef}>
      <div className="drp-input" onClick={toggle}>
        {startDate && endDate
          ? isSameDay(startDate, endDate)
            ? format(startDate, "d MMM ''yy")
            : `${format(startDate, "d MMM ''yy")} - ${format(
                endDate,
                "d MMM ''yy",
              )}`
          : "Select Date Range"}
      </div>

      {isOpen && (
        <div className="drp-dropdown">
          <div className="drp-header">
            <span>{format(currentMonth, "MMMM yyyy")}</span>
            <div className="flex items-center">
              <div onClick={() => setCurrentMonth(subMonths(currentMonth, 1))}>
                ◀&nbsp;&nbsp;&nbsp;
              </div>
              <div onClick={() => setCurrentMonth(addMonths(currentMonth, 1))}>
                ▶
              </div>
            </div>
          </div>

          <div className="drp-weekdays">
            {["M", "T", "W", "T", "F", "S", "S"].map((d, i) => (
              <div key={`${d}-${i}`}>{d}</div>
            ))}
          </div>

          <div className="drp-grid">
            {days.map((day) => {
              const selected =
                isSameDay(day, startDate) || isSameDay(day, endDate);

              return (
                <div
                  key={day}
                  onClick={() => selectDate(day)}
                  className={`drp-day 
                    ${selected ? "selected" : ""} 
                    ${isInRange(day) ? "in-range" : ""}
                  `}
                >
                  {format(day, "d")}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
};

export default CustomCalendar;
